module.exports = new __parcel__URL__("jsm-user-limit.0196cbe5.png").toString();